<template>
  <div :style="{ marginTop: '20px', paddingBottom: '80px' }">

    <div v-if="!loading">

      <!-- Group Message Sender -->
      <b-card no-body class="alert-section-card mb-2" data-section="isGroupMessageSenderVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isGroupMessageSenderVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isGroupMessageSenderVisible }">&#9654;</span>
          <span class="alert-section-title">Group Message Sender</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.group_message_sender_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isGroupMessageSenderVisible" :visible="!!toggle.isGroupMessageSenderVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="group_message_sender_test_mode">
                <td class="alert-label">Test Mode</td>
                <td><b-form-select v-model="model.group_message_sender_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="group_message_sender_include_telematics_drivers">
                <td class="alert-label">Include Telematics Drivers</td>
                <td><b-form-select v-model="model.group_message_sender_include_telematics_drivers" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Driver Pre Trip Notifications -->
      <b-card no-body class="alert-section-card mb-2" data-section="isDriverPreVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isDriverPreVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isDriverPreVisible }">&#9654;</span>
          <span class="alert-section-title">Driver Pre Trip Notifications</span>
          <div class="ml-auto" @click.stop>
            <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mr-2" @click="confirmDefaults('Set default values for Driver Pre Trip Notifications? This will overwrite current settings.', apply_driver_pre_trip_defaults)">Set Defaults</b-btn>
            <b-form-select v-model="model.driver_trip_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isDriverPreVisible" :visible="!!toggle.isDriverPreVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="driver_trip_notifications_test_mode">
                <td class="alert-label">Test Mode</td>
                <td><b-form-select v-model="model.driver_trip_notifications_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="driver_trip_notifications_contracts_enabled">
                <td class="alert-label">Contracts Enabled</td>
                <td><b-form-select v-model="model.driver_trip_notifications_contracts_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="driver_trip_notifications_private_hires_enabled">
                <td class="alert-label">Private Hires Enabled</td>
                <td><b-form-select v-model="model.driver_trip_notifications_private_hires_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="driver_trip_notifications_enable_booking_updates">
                <td class="alert-label">Booking Updates Enabled</td>
                <td><b-form-select v-model="model.driver_trip_notifications_enable_booking_updates" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="driver_trip_notifications_send_hours_before">
                <td class="alert-label">Send Hours Before</td>
                <td>
                  <b-form-input v-model="model.driver_trip_notifications_send_hours_before" type="text" :state="numericState('driver_trip_notifications_send_hours_before')" @input="validateNumeric('driver_trip_notifications_send_hours_before', $event, 0, 168)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('driver_trip_notifications_send_hours_before')">{{ numericFeedback('driver_trip_notifications_send_hours_before') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="driver_trip_notifications_send_hours_before_by_day">
                <td class="alert-label">Send Hours Before By Day</td>
                <td><b-form-input v-model="model.driver_trip_notifications_send_hours_before_by_day" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_trip_notifications_send_only_at_hour">
                <td class="alert-label">Send Only At Hour</td>
                <td>
                  <b-form-input v-model="model.driver_trip_notifications_send_only_at_hour" type="text" :state="numericState('driver_trip_notifications_send_only_at_hour')" @input="validateNumeric('driver_trip_notifications_send_only_at_hour', $event, 0, 23)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('driver_trip_notifications_send_only_at_hour')">{{ numericFeedback('driver_trip_notifications_send_only_at_hour') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="driver_trip_notifications_business_hours">
                <td class="alert-label">Send Only During Business Hours</td>
                <td><b-form-input v-model="model.driver_trip_notifications_business_hours" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_trip_notifications_response_email_recipients">
                <td class="alert-label">Response Email Recipients</td>
                <td><b-form-input v-model="model.driver_trip_notifications_response_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_trip_notifications_response_email_config">
                <td class="alert-label">Response Email Config</td>
                <td>
                  <JsonObjectListEditor v-model="model.driver_trip_notifications_response_email_config" fieldKey="driver_trip_notifications_response_email_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="response_email_config_columns"/>
                  <b-form-invalid-feedback :state="jsonState('driver_trip_notifications_response_email_config')">{{ jsonFeedback('driver_trip_notifications_response_email_config') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="driver_trip_notifications_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.driver_trip_notifications_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_trip_notifications_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.driver_trip_notifications_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_trip_notifications_failed_sms_recipients">
                <td class="alert-label">SMS Failure Recipients</td>
                <td><b-form-input v-model="model.driver_trip_notifications_failed_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_trip_notifications_confirmation_enabled">
                <td class="alert-label">Confirmation Enabled</td>
                <td><b-form-select v-model="model.driver_trip_notifications_confirmation_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="driver_trip_notifications_nudge_enabled">
                <td class="alert-label">Confirmation Nudge Enabled</td>
                <td><b-form-select v-model="model.driver_trip_notifications_nudge_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="driver_trip_notifications_confirmation_minutes">
                <td class="alert-label">Confirmation Minutes</td>
                <td>
                  <b-form-input v-model="model.driver_trip_notifications_confirmation_minutes" type="text" :state="numericState('driver_trip_notifications_confirmation_minutes')" @input="validateNumeric('driver_trip_notifications_confirmation_minutes', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('driver_trip_notifications_confirmation_minutes')">{{ numericFeedback('driver_trip_notifications_confirmation_minutes') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="driver_trip_notifications_confirmation_email_recipients">
                <td class="alert-label">Confirmation Email Recipients</td>
                <td><b-form-input v-model="model.driver_trip_notifications_confirmation_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_trip_notifications_confirmation_advanced_config">
                <td class="alert-label">Confirmation Advanced Config</td>
                <td>
                  <JsonObjectListEditor v-model="model.driver_trip_notifications_confirmation_advanced_config" fieldKey="driver_trip_notifications_confirmation_advanced_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="confirmation_advanced_columns"/>
                  <b-form-invalid-feedback :state="jsonState('driver_trip_notifications_confirmation_advanced_config')">{{ jsonFeedback('driver_trip_notifications_confirmation_advanced_config') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="driver_trip_notifications_skip_routes">
                <td class="alert-label">Skip By Route Name</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.driver_trip_notifications_skip_routes"
                    fieldKey="driver_trip_notifications_skip_routes"
                    variant="wildcard"
                    placeholder="add any part of a route name and press enter..."
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr v-if="telematics_type == 'SAMSARA'" data-field="driver_trip_notifications_vehicle_tag_filter">
                <td class="alert-label">Vehicle Tag Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.driver_trip_notifications_vehicle_tag_filter"
                    fieldKey="driver_trip_notifications_vehicle_tag_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="driver_trip_notifications_skip_non_telematics_vehicles">
                <td class="alert-label">Skip Non Telematics Vehicles</td>
                <td><b-form-select v-model="model.driver_trip_notifications_skip_non_telematics_vehicles" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="telematics_type == 'SAMSARA'" data-field="driver_trip_notifications_driver_tag_filter">
                <td class="alert-label">Driver Tag Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.driver_trip_notifications_driver_tag_filter"
                    fieldKey="driver_trip_notifications_driver_tag_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="driver_trip_notifications_driver_name_filter">
                <td class="alert-label">Driver Name Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.driver_trip_notifications_driver_name_filter"
                    fieldKey="driver_trip_notifications_driver_name_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="driver_trip_notifications_client_id_filter">
                <td class="alert-label">Client ID Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.driver_trip_notifications_client_id_filter"
                    fieldKey="driver_trip_notifications_client_id_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr v-if="tenant_type == 'TBN'" data-field="driver_trip_notifications_org_name_filter">
                <td class="alert-label">Organization Name Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.driver_trip_notifications_org_name_filter"
                    fieldKey="driver_trip_notifications_org_name_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="driver_trip_notifications_booking_base_filter">
                <td class="alert-label">Booking Base Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.driver_trip_notifications_booking_base_filter"
                    fieldKey="driver_trip_notifications_booking_base_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="driver_trip_notifications_booking_poc_field">
                <td class="alert-label">Booking POC Field</td>
                <td><b-form-input v-model="model.driver_trip_notifications_booking_poc_field" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_trip_notifications_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><PfsRichEditor ref="driverTripSmsRef" v-model="model.driver_trip_notifications_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.driverTrip" :editor-ref="$refs.driverTripSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr v-if="tenant_type == 'TBN'" data-field="driver_trip_notifications_driver_instruction_marker">
                <td class="alert-label">Driver Instructions Marker</td>
                <td><b-form-input v-model="model.driver_trip_notifications_driver_instruction_marker" type="text"></b-form-input></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Driver Post Trip Notification -->
      <b-card no-body class="alert-section-card mb-2" data-section="isDriverPostVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isDriverPostVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isDriverPostVisible }">&#9654;</span>
          <span class="alert-section-title">Driver Post Trip Notification</span>
          <div class="ml-auto" @click.stop>
            <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mr-2" @click="confirmDefaults('Set default values for Driver Post Trip Notification? This will overwrite current settings.', apply_driver_post_trip_defaults)">Set Defaults</b-btn>
            <b-form-select v-model="model.post_trip_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isDriverPostVisible" :visible="!!toggle.isDriverPostVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="post_trip_notifications_email_only">
                <td class="alert-label">Email Only</td>
                <td><b-form-select v-model="model.post_trip_notifications_email_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="post_trip_notifications_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.post_trip_notifications_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="post_trip_notifications_send_after_complete">
                <td class="alert-label">Send After Complete</td>
                <td><b-form-select v-model="model.post_trip_notifications_send_after_complete" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="post_trip_notifications_confirmation_enabled">
                <td class="alert-label">Confirmation Enabled</td>
                <td><b-form-select v-model="model.post_trip_notifications_confirmation_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="post_trip_notifications_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.post_trip_notifications_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="post_trip_notifications_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.post_trip_notifications_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="post_trip_notifications_booking_type_filter">
                <td class="alert-label">Filter By Booking Type</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.post_trip_notifications_booking_type_filter"
                    fieldKey="post_trip_notifications_booking_type_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="post_trip_notifications_send_minutes_after">
                <td class="alert-label">Send Minutes After</td>
                <td>
                  <b-form-input v-model="model.post_trip_notifications_send_minutes_after" type="text" :state="numericState('post_trip_notifications_send_minutes_after')" @input="validateNumeric('post_trip_notifications_send_minutes_after', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('post_trip_notifications_send_minutes_after')">{{ numericFeedback('post_trip_notifications_send_minutes_after') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="post_trip_notifications_response_email_recipients">
                <td class="alert-label">Response Email Recipients</td>
                <td><b-form-input v-model="model.post_trip_notifications_response_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="post_trip_notifications_response_email_config">
                <td class="alert-label">Response Email Config</td>
                <td>
                  <JsonObjectListEditor v-model="model.post_trip_notifications_response_email_config" fieldKey="post_trip_notifications_response_email_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="post_trip_response_email_columns"/>
                  <b-form-invalid-feedback :state="jsonState('post_trip_notifications_response_email_config')">{{ jsonFeedback('post_trip_notifications_response_email_config') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="post_trip_notifications_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><PfsRichEditor ref="postTripSmsRef" v-model="model.post_trip_notifications_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.driverPostTrip" :editor-ref="$refs.postTripSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr data-field="post_trip_notifications_confirmation_minutes">
                <td class="alert-label">Confirmation Minutes</td>
                <td>
                  <b-form-input v-model="model.post_trip_notifications_confirmation_minutes" type="text" :state="numericState('post_trip_notifications_confirmation_minutes')" @input="validateNumeric('post_trip_notifications_confirmation_minutes', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('post_trip_notifications_confirmation_minutes')">{{ numericFeedback('post_trip_notifications_confirmation_minutes') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="post_trip_notifications_confirmation_email_recipients">
                <td class="alert-label">Confirmation Email Address</td>
                <td><b-form-input v-model="model.post_trip_notifications_confirmation_email_recipients" type="text"></b-form-input></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Customer Pre Trip Notification -->
      <b-card no-body class="alert-section-card mb-2" data-section="isCustomerPreVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isCustomerPreVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isCustomerPreVisible }">&#9654;</span>
          <span class="alert-section-title">Customer Pre Trip Notification</span>
          <div class="ml-auto" @click.stop>
            <b-button variant="outline-secondary" size="sm" class="mr-2" @click="open_manage_cust_events">Manage Alert Settings</b-button>
            <b-form-select v-model="model.customer_trip_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isCustomerPreVisible" :visible="!!toggle.isCustomerPreVisible">
          <b-card-body>
            <div>
              <b-card no-body class="alert-section-card mb-2 mt-2" data-section="isCustDefaultSettingsVisible">
                <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isCustDefaultSettingsVisible')">
                  <span class="alert-chevron mr-2" :class="{ open: toggle.isCustDefaultSettingsVisible }">&#9654;</span>
                  <span class="alert-section-title">Default Settings</span>
                </b-card-header>
                <b-collapse id="collapse-isCustDefaultSettingsVisible" :visible="!!toggle.isCustDefaultSettingsVisible">
                  <b-card-body>
                    <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr v-if="tenant_type == 'CM'" data-field="customer_trip_notifications_enable_booking_updates">
                <td class="alert-label">Resend On Booking Update Enabled</td>
                <td><b-form-select v-model="model.customer_trip_notifications_enable_booking_updates" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="customer_trip_notifications_update_max_hours_before_trip">
                <td class="alert-label">Only Resend Update If Trip Is Within (Hrs)</td>
                <td>
                  <b-form-input v-model="model.customer_trip_notifications_update_max_hours_before_trip" type="text" :state="numericState('customer_trip_notifications_update_max_hours_before_trip')" @input="validateNumeric('customer_trip_notifications_update_max_hours_before_trip', $event, 0, 168)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('customer_trip_notifications_update_max_hours_before_trip')">{{ numericFeedback('customer_trip_notifications_update_max_hours_before_trip') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="customer_trip_notifications_show_unassigned_driver">
                <td class="alert-label">Show 'To Be Assigned' When No Driver</td>
                <td><b-form-select v-model="model.customer_trip_notifications_show_unassigned_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_aaahi" data-field="customer_trip_notifications_api_enabled">
                <td class="alert-label">External API Mode Enabled</td>
                <td><b-form-select v-model="model.customer_trip_notifications_api_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="customer_trip_notifications_contracts_enabled">
                <td class="alert-label">Default Send To Contracts Enabled</td>
                <td><b-form-select v-model="model.customer_trip_notifications_contracts_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_aaahi" data-field="customer_trip_notifications_include_driver_name_with_farm_out">
                <td class="alert-label">Default Include Driver Name With Farm Out Info</td>
                <td><b-form-select v-model="model.customer_trip_notifications_include_driver_name_with_farm_out" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="customer_trip_notifications_private_hires_enabled">
                <td class="alert-label">Default Send To Private Hires Enabled</td>
                <td><b-form-select v-model="model.customer_trip_notifications_private_hires_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="customer_trip_notifications_booking_poc_field">
                <td class="alert-label">Default Booking Field To Find POC Info</td>
                <td><b-form-input v-model="model.customer_trip_notifications_booking_poc_field" type="text"></b-form-input></td>
              </tr>
              <tr data-field="customer_trip_notifications_email_recipients">
                <td class="alert-label">Default Email Recipients</td>
                <td><b-form-input v-model="model.customer_trip_notifications_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="customer_trip_notifications_poc_error_email_recipients">
                <td class="alert-label">Default POC Error Email Recipients</td>
                <td><b-form-input v-model="model.customer_trip_notifications_poc_error_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="customer_trip_notifications_failed_sms_recipients">
                <td class="alert-label">Default SMS Failure Recipients</td>
                <td><b-form-input v-model="model.customer_trip_notifications_failed_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="customer_trip_notifications_failed_email_recipients">
                <td class="alert-label">Default Email Failure Recipients</td>
                <td><b-form-input v-model="model.customer_trip_notifications_failed_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="customer_trip_notifications_image_site_url">
                <td class="alert-label">Image Site URL</td>
                <td><b-form-input v-model="model.customer_trip_notifications_image_site_url" type="text"></b-form-input></td>
              </tr>
              <tr data-field="customer_trip_notifications_email_sender_prefix">
                <td class="alert-label">Email Sender Prefix</td>
                <td><b-form-input v-model="model.customer_trip_notifications_email_sender_prefix" type="text"></b-form-input></td>
              </tr>
              <tr data-field="customer_trip_notifications_email_subject">
                <td class="alert-label">Default Email Subject</td>
                <td>
                  <PfsRichEditor ref="custTripEmailSubjectRef" v-model="model.customer_trip_notifications_email_subject" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.customerAlertEmailSubject" :editor-ref="$refs.custTripEmailSubjectRef" :tenant-type="tenant_type"/>
                </td>
              </tr>
              <tr data-field="customer_trip_notifications_email_response_forward_address">
                <td class="alert-label">Default SMS/Email Response Forward Address</td>
                <td><b-form-input v-model="model.customer_trip_notifications_email_response_forward_address" type="text"></b-form-input></td>
              </tr>
              <tr data-field="customer_trip_notifications_email_reply_recipients">
                <td class="alert-label">Default Email Reply-To Recipients</td>
                <td><b-form-input v-model="model.customer_trip_notifications_email_reply_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="customer_trip_notifications_email_config">
                <td class="alert-label">Default Email Config</td>
                <td>
                  <JsonObjectListEditor v-model="model.customer_trip_notifications_email_config" fieldKey="customer_trip_notifications_email_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="customer_email_config_columns"/>
                  <b-form-invalid-feedback :state="jsonState('customer_trip_notifications_email_config')">{{ jsonFeedback('customer_trip_notifications_email_config') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr v-if="tenant_type == 'TBN'" data-field="customer_trip_notifications_route_filter">
                <td class="alert-label">Route Description Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.customer_trip_notifications_route_filter"
                    fieldKey="customer_trip_notifications_route_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
                    </table>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <!-- (non-migrated view removed: all tenants are now on the migrated-to-events path) -->
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Customer Post Trip Notification -->
      <b-card no-body class="alert-section-card mb-2" data-section="isCustomerPostVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isCustomerPostVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isCustomerPostVisible }">&#9654;</span>
          <span class="alert-section-title">Customer Post Trip Notification</span>
          <div class="ml-auto" @click.stop>
            <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mr-2" @click="confirmDefaults('Set default values for Customer Post Trip Notification? This will overwrite current settings.', apply_customer_post_trip_defaults)">Set Defaults</b-btn>
            <b-form-select v-model="model.customer_post_trip_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isCustomerPostVisible" :visible="!!toggle.isCustomerPostVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="customer_post_trip_notifications_test_mode">
                <td class="alert-label">Test Mode</td>
                <td><b-form-select v-model="model.customer_post_trip_notifications_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="customer_post_trip_notifications_send_only_at_hour">
                <td class="alert-label">Send Only At Hour</td>
                <td>
                  <b-form-input v-model="model.customer_post_trip_notifications_send_only_at_hour" type="text" :state="numericState('customer_post_trip_notifications_send_only_at_hour')" @input="validateNumeric('customer_post_trip_notifications_send_only_at_hour', $event, 0, 23)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('customer_post_trip_notifications_send_only_at_hour')">{{ numericFeedback('customer_post_trip_notifications_send_only_at_hour') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="customer_post_trip_notifications_send_minutes_after_planned_dropoff">
                <td class="alert-label">Minutes After Planned Drop Off</td>
                <td>
                  <b-form-input v-model="model.customer_post_trip_notifications_send_minutes_after_planned_dropoff" type="text" :state="numericState('customer_post_trip_notifications_send_minutes_after_planned_dropoff')" @input="validateNumeric('customer_post_trip_notifications_send_minutes_after_planned_dropoff', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('customer_post_trip_notifications_send_minutes_after_planned_dropoff')">{{ numericFeedback('customer_post_trip_notifications_send_minutes_after_planned_dropoff') }}</b-form-invalid-feedback>
                  <span class="help-block">If set, sends customer post trip notifications this many minutes after planned drop off.</span>
                </td>
              </tr>
              <tr data-field="customer_post_trip_notifications_send_minutes_before_planned_dropoff">
                <td class="alert-label">Minutes Before Planned Drop Off</td>
                <td>
                  <b-form-input v-model="model.customer_post_trip_notifications_send_minutes_before_planned_dropoff" type="text" :state="numericState('customer_post_trip_notifications_send_minutes_before_planned_dropoff')" @input="validateNumeric('customer_post_trip_notifications_send_minutes_before_planned_dropoff', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('customer_post_trip_notifications_send_minutes_before_planned_dropoff')">{{ numericFeedback('customer_post_trip_notifications_send_minutes_before_planned_dropoff') }}</b-form-invalid-feedback>
                  <span class="help-block">If set, sends customer post trip notifications this many minutes before planned drop off.</span>
                </td>
              </tr>
              <tr data-field="customer_post_trip_notifications_booking_poc_field">
                <td class="alert-label">Booking POC Field</td>
                <td><b-form-input v-model="model.customer_post_trip_notifications_booking_poc_field" type="text"></b-form-input></td>
              </tr>
              <tr data-field="customer_post_trip_notifications_use_primary_contact">
                <td class="alert-label">Use Primary Contact</td>
                <td><b-form-select v-model="model.customer_post_trip_notifications_use_primary_contact" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="customer_post_trip_notifications_use_operations_contact">
                <td class="alert-label">Use Operations Contact</td>
                <td><b-form-select v-model="model.customer_post_trip_notifications_use_operations_contact" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="customer_post_trip_notifications_email_subject">
                <td class="alert-label">Email Subject</td>
                <td>
                  <PfsRichEditor ref="custPostTripEmailSubjectRef" v-model="model.customer_post_trip_notifications_email_subject" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.customerPostTripEmailSubject" :editor-ref="$refs.custPostTripEmailSubjectRef" :tenant-type="tenant_type"/>
                </td>
              </tr>
              <tr data-field="customer_post_trip_notifications_email_config">
                <td class="alert-label">Email Config</td>
                <td>
                  <JsonObjectListEditor v-model="model.customer_post_trip_notifications_email_config" fieldKey="customer_post_trip_notifications_email_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="customer_email_config_columns"/>
                  <b-form-invalid-feedback :state="jsonState('customer_post_trip_notifications_email_config')">{{ jsonFeedback('customer_post_trip_notifications_email_config') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="customer_post_trip_notifications_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.customer_post_trip_notifications_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="customer_post_trip_notifications_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.customer_post_trip_notifications_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="customer_post_trip_notifications_poc_error_email_recipients">
                <td class="alert-label">POC Error Email Recipients</td>
                <td><b-form-input v-model="model.customer_post_trip_notifications_poc_error_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="customer_post_trip_notifications_group_field">
                <td class="alert-label">Group Field</td>
                <td><b-form-input v-model="model.customer_post_trip_notifications_group_field" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'TBN'" data-field="customer_post_trip_notifications_route_filter">
                <td class="alert-label">Route Description Filter</td>
                <td>
                  <FilterSettingEditor
                    v-model="model.customer_post_trip_notifications_route_filter"
                    fieldKey="customer_post_trip_notifications_route_filter"
                    variant="wildcard"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="customer_post_trip_notifications_per_charter_enabled">
                <td class="alert-label">Send Once Per Charter (not per movement)</td>
                <td><b-form-select v-model="model.customer_post_trip_notifications_per_charter_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="customer_post_trip_notifications_client_cooldown_enabled">
                <td class="alert-label" valign="top">Client Cooldown Enabled</td>
                <td><b-form-select v-model="model.customer_post_trip_notifications_client_cooldown_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'CM' && (model.customer_post_trip_notifications_client_cooldown_enabled === true || model.customer_post_trip_notifications_client_cooldown_enabled === 'True')" data-field="customer_post_trip_notifications_client_cooldown_months">
                <td class="alert-label">Client Cooldown (months)</td>
                <td>
                  <b-form-input v-model="model.customer_post_trip_notifications_client_cooldown_months" type="text" :state="numericState('customer_post_trip_notifications_client_cooldown_months')" @input="validateNumeric('customer_post_trip_notifications_client_cooldown_months', $event, 1, 12)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('customer_post_trip_notifications_client_cooldown_months')">{{ numericFeedback('customer_post_trip_notifications_client_cooldown_months') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="customer_post_trip_notifications_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><PfsRichEditor ref="customerPostTripSmsRef" v-model="model.customer_post_trip_notifications_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.customerPostTrip" :editor-ref="$refs.customerPostTripSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr data-field="customer_post_trip_notifications_email_template">
                <td class="alert-label">Email HTML Template</td>
                <td>
                  <PfsRichEditor ref="customerPostTripEmailRef" v-model="model.customer_post_trip_notifications_email_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.customerPostTrip" :editor-ref="$refs.customerPostTripEmailRef" :tenant-type="tenant_type"/>
                  <b-button variant="outline-secondary" style="margin-top: 5px" @click="show_html_in_browser(model.customer_post_trip_notifications_email_template)">Show html in browser</b-button>
                </td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Customer Survey Notifications (AAAHI only) -->
      <b-card v-if="tenant_aaahi" no-body class="alert-section-card mb-2" data-section="isDriverSurveyVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isDriverSurveyVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isDriverSurveyVisible }">&#9654;</span>
          <span class="alert-section-title">Customer Survey Notifications</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.driver_surveys_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isDriverSurveyVisible" :visible="!!toggle.isDriverSurveyVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="driver_surveys_email_only">
                <td class="alert-label">Email Only</td>
                <td><b-form-select v-model="model.driver_surveys_email_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="driver_surveys_test_email_only">
                <td class="alert-label">Test Email Only</td>
                <td><b-form-select v-model="model.driver_surveys_test_email_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="driver_surveys_prevent_duplicates">
                <td class="alert-label">Prevent Duplicates</td>
                <td><b-form-select v-model="model.driver_surveys_prevent_duplicates" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="driver_surveys_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.driver_surveys_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_surveys_email_subject">
                <td class="alert-label">Email Subject</td>
                <td><b-form-input v-model="model.driver_surveys_email_subject" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_surveys_send_only_at_hour">
                <td class="alert-label">Send Only At Hour</td>
                <td>
                  <b-form-input v-model="model.driver_surveys_send_only_at_hour" type="text" :state="numericState('driver_surveys_send_only_at_hour')" @input="validateNumeric('driver_surveys_send_only_at_hour', $event, 0, 23)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('driver_surveys_send_only_at_hour')">{{ numericFeedback('driver_surveys_send_only_at_hour') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="driver_surveys_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><PfsRichEditor ref="driverSurveysSmsRef" v-model="model.driver_surveys_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.driverSurvey" :editor-ref="$refs.driverSurveysSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr data-field="driver_surveys_html_template">
                <td class="alert-label">HTML Template</td>
                <td>
                  <PfsRichEditor ref="driverSurveysHtmlRef" v-model="model.driver_surveys_html_template"/>
                  <PfsFieldHelp :fields="pfsNotifFields.driverSurvey" :editor-ref="$refs.driverSurveysHtmlRef" :tenant-type="tenant_type"/>
                  <a target='_blank' :href="'https://api.fleet-integrations.com/bookings/alerts/showHtml?tenant=' + user.tenant + '&type=driver'">
                    <b-button variant="outline-secondary" style="margin-top:5px">Show html in browser</b-button>
                  </a>
                </td>
              </tr>
              <tr data-field="driver_surveys_test_html_email_address">
                <td class="alert-label">Test HTML Email Address</td>
                <td><b-form-input v-model="model.driver_surveys_test_html_email_address" type="text"></b-form-input></td>
              </tr>
              <tr>
                <td class="alert-label">Send Test HTML Email</td>
                <td><b-button variant="outline-secondary" @click="test_driver_survey_alert_html()">Send Email To Above Address</b-button></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Passenger Pre Trip Notification (CM only) -->
      <b-card v-if="tenant_type == 'CM'" no-body class="alert-section-card mb-2" data-section="isPassPreVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isPassPreVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isPassPreVisible }">&#9654;</span>
          <span class="alert-section-title">Passenger Pre Trip Notification</span>
          <div class="ml-auto" @click.stop>
            <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mr-2" @click="confirmDefaults('Set default values for Passenger Pre Trip Notification? This will overwrite current settings.', apply_passenger_pre_trip_defaults)">Set Defaults</b-btn>
            <b-form-select v-model="model.passenger_trip_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isPassPreVisible" :visible="!!toggle.isPassPreVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="passenger_trip_notifications_email_only">
                <td class="alert-label">Email Only</td>
                <td><b-form-select v-model="model.passenger_trip_notifications_email_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="passenger_trip_notifications_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.passenger_trip_notifications_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="passenger_trip_notifications_hours_before">
                <td class="alert-label">Hours Before</td>
                <td>
                  <b-form-input v-model="model.passenger_trip_notifications_hours_before" type="text" :state="numericState('passenger_trip_notifications_hours_before')" @input="validateNumeric('passenger_trip_notifications_hours_before', $event, 0, 168)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('passenger_trip_notifications_hours_before')">{{ numericFeedback('passenger_trip_notifications_hours_before') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="passenger_trip_notifications_skip_bookings">
                <td class="alert-label">Skip Bookings</td>
                <td><b-form-input v-model="model.passenger_trip_notifications_skip_bookings" type="text"></b-form-input></td>
              </tr>
              <tr data-field="passenger_trip_notifications_sms_template_day_of">
                <td class="alert-label">SMS Template Day Of</td>
                <td><PfsRichEditor ref="passengerDayOfSmsRef" v-model="model.passenger_trip_notifications_sms_template_day_of" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.passenger" :editor-ref="$refs.passengerDayOfSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr data-field="passenger_trip_notifications_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><PfsRichEditor ref="passengerSmsRef" v-model="model.passenger_trip_notifications_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.passenger" :editor-ref="$refs.passengerSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr v-if="this.user.tenant == '9804c73f-80ba-41d4-9a96-f69acc79478d'" data-field="passenger_trip_notifications_sms_template_tour_type">
                <td class="alert-label">SMS Template For Tour Types</td>
                <td><PfsRichEditor ref="passengerTourSmsRef" v-model="model.passenger_trip_notifications_sms_template_tour_type" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.passenger" :editor-ref="$refs.passengerTourSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr v-if="this.user.tenant == '9804c73f-80ba-41d4-9a96-f69acc79478d'" data-field="passenger_trip_notifications_sms_template_cruise_express">
                <td class="alert-label">SMS Template For Cruise Express</td>
                <td><PfsRichEditor ref="passengerCruiseSmsRef" v-model="model.passenger_trip_notifications_sms_template_cruise_express" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.passenger" :editor-ref="$refs.passengerCruiseSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr v-if="this.user.tenant == '9804c73f-80ba-41d4-9a96-f69acc79478d'" data-field="passenger_trip_notifications_sms_template_florida_cruise_express">
                <td class="alert-label">SMS Template For Florida Cruise Express</td>
                <td><PfsRichEditor ref="passengerFloridaCruiseSmsRef" v-model="model.passenger_trip_notifications_sms_template_florida_cruise_express" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.passenger" :editor-ref="$refs.passengerFloridaCruiseSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Relay Notifications (CM only) -->
      <b-card v-if="tenant_type == 'CM'" no-body class="alert-section-card mb-2" data-section="isRelayVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isRelayVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isRelayVisible }">&#9654;</span>
          <span class="alert-section-title">Relay Notifications</span>
          <div class="ml-auto" @click.stop>
            <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mr-2" @click="confirmDefaults('Set default values for Relay Notifications? This will overwrite current settings.', apply_relay_defaults)">Set Defaults</b-btn>
            <b-form-select v-model="model.relay_notifications_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isRelayVisible" :visible="!!toggle.isRelayVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="relay_notifications_test_mode">
                <td class="alert-label">Test Mode (Alert record, no email or sms sent)</td>
                <td><b-form-select v-model="model.relay_notifications_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="relay_notifications_email_only">
                <td class="alert-label">Email Only</td>
                <td><b-form-select v-model="model.relay_notifications_email_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="relay_notifications_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.relay_notifications_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="relay_notifications_poc_error_email_recipients">
                <td class="alert-label">POC Error Email Recipients</td>
                <td><b-form-input v-model="model.relay_notifications_poc_error_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="relay_notifications_minutes_threshold">
                <td class="alert-label">Minutes Threshold</td>
                <td>
                  <b-form-input v-model="model.relay_notifications_minutes_threshold" type="text" :state="numericState('relay_notifications_minutes_threshold')" @input="validateNumeric('relay_notifications_minutes_threshold', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('relay_notifications_minutes_threshold')">{{ numericFeedback('relay_notifications_minutes_threshold') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="relay_notifications_distance_threshold">
                <td class="alert-label">Distance Threshold</td>
                <td>
                  <b-form-input v-model="model.relay_notifications_distance_threshold" type="text" :state="numericState('relay_notifications_distance_threshold')" @input="validateNumeric('relay_notifications_distance_threshold', $event, 0, 1000)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('relay_notifications_distance_threshold')">{{ numericFeedback('relay_notifications_distance_threshold') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="relay_notifications_minutes_before">
                <td class="alert-label">Minutes Before</td>
                <td>
                  <b-form-input v-model="model.relay_notifications_minutes_before" type="text" :state="numericState('relay_notifications_minutes_before')" @input="validateNumeric('relay_notifications_minutes_before', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('relay_notifications_minutes_before')">{{ numericFeedback('relay_notifications_minutes_before') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="relay_notifications_minutes_after">
                <td class="alert-label">Minutes After</td>
                <td>
                  <b-form-input v-model="model.relay_notifications_minutes_after" type="text" :state="numericState('relay_notifications_minutes_after')" @input="validateNumeric('relay_notifications_minutes_after', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('relay_notifications_minutes_after')">{{ numericFeedback('relay_notifications_minutes_after') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="relay_notifications_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><PfsRichEditor ref="relayNotifSmsRef" v-model="model.relay_notifications_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.relay" :editor-ref="$refs.relayNotifSmsRef" :tenant-type="tenant_type"/></td>
              </tr>
              <tr data-field="relay_notifications_api_enabled">
                <td class="alert-label">API Enabled</td>
                <td><b-form-select v-model="model.relay_notifications_api_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <b-modal title="Manage Cust Alert Settings" size="huge" v-model="manage_cust_events" ok-only id="custModal" @ok="custModelOK($event)" @hidden="reset_cust_event_modal_state">
      <div style="color:red; font-weight:bold;" v-if="this.show_cust_error">
        <b>{{this.cust_error_msg}}</b><br/>
      </div>
      <b> If Send Hour is added, this will be the only hour the alert will send (HoursByDay/OnlyAtHour). But if business hours is set outside of the send hour, the alert will not be sent. (Only set Send Hour inside business hours)
        <br/><br/>Customize template text and add any of available fields (Click on Available Fields links)
        </b><br/><br/>
      <div v-if="loading">
        <b-spinner style="width: 2rem; height: 1rem;" label="Loading..."></b-spinner>
      </div>
      <div v-else>
        <b-table v-if="this.cust_alert_event_settings" :items="this.cust_alert_event_settings" :fields="['eventName','eventType','hours','sendHour','business_hours', 'sms_recipients','email_recipients','test_mode','update','remove']">
          <template slot="update" slot-scope="row">
            <b-button size="sm" @click="update_cust_event(row.item.eventName)">update</b-button>
            <br/>
          </template>
          <template slot="remove" slot-scope="row">
            <b-button size="sm" @click="delete_cust_event(row.item.eventName)">remove</b-button>
          </template>
        </b-table>
        <hr/>
        <b-btn v-if="isEffectiveAdmin" variant="outline-secondary" size="sm" class="mb-2" @click="confirmDefaults('Add the default Customer Pre Trip notification events (Day Before Notification, 1 Hour Before)? Events you already have with those names are left alone.', apply_customer_pre_trip_event_defaults, 'Add Default Events')">Add Default Events</b-btn><br/>
        <div style="font-weight: bold; font-size: 18px;" v-on:click="add_new_alert()">&#43; Add New Alert</div><br/>
        <span :style="toggle.isAddCustEventVisible ? '' : 'display:none'">
            <div><b>
              Event type: <b-form-select v-model="add_cust_event_model.eventType" :options="cust_event_options" @change="eval_event" :disabled=disable_cust_options style="width:200px"></b-form-select><p/>
              Test Mode Enabled: <b-form-select v-model="add_cust_event_model.test_mode" :options="boolean_options" style="width:200px"/><p/>
              Event name: <b-form-input v-model="add_cust_event_model.eventName" required :disabled=disable_cust_name></b-form-input>
              <span :style="!isHrsBfDisabled(add_cust_event_model) ? '' : 'display:none'">
              Send Hour(s) Before: <b-form-input v-model="add_cust_event_model.hours" :disabled=isHrsBfDisabled(add_cust_event_model)></b-form-input>
              </span>
              <span :style="isSendHoursEnabled(add_cust_event_model) ? '' : 'display:none'">
              Send Only At Hour: <b-form-input v-model="add_cust_event_model.sendHour" :disabled=!isSendHoursEnabled(add_cust_event_model)></b-form-input>
              </span>
              <span :style="!isDayDisabled(add_cust_event_model) ? '' : 'display:none'">
              Monday: <b-form-input v-model="add_cust_event_model.M" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Tuesday: <b-form-input v-model="add_cust_event_model.T" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Wednesday: <b-form-input v-model="add_cust_event_model.W" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Thursday: <b-form-input v-model="add_cust_event_model.TH" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Friday: <b-form-input v-model="add_cust_event_model.F" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Saturday: <b-form-input v-model="add_cust_event_model.SA" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              Sunday: <b-form-input v-model="add_cust_event_model.SU" :disabled=isDayDisabled(add_cust_event_model)></b-form-input>
              </span>
              <span :style="!isBusHrsDisabled(add_cust_event_model) ? '' : 'display:none'">
              Send During Business Hours: <b-form-input v-model="add_cust_event_model.business_hours" :disabled="isBusHrsDisabled(add_cust_event_model)"/>
              </span>
              SMS Recipients: <b-form-input v-model="add_cust_event_model.sms_recipients" />
              Email Recipients: <b-form-input v-model="add_cust_event_model.email_recipients" />
              SMS Template: 
                <PfsRichEditor ref="customerTripSmsTRef" v-model="add_cust_event_model.template" style="field-sizing: content; max-width: 800px" required/>
                  <PfsFieldHelp :fields="pfsNotifFields.customerAlert" :editor-ref="$refs.customerTripSmsTRef" :tenant-type="tenant_type"/></br>
              Email Template:
                  <PfsRichEditor ref="customerEmailTemplateRef" v-model="add_cust_event_model.email_html_template" style="field-sizing: content; max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.customerPreTripEmail" :editor-ref="$refs.customerEmailTemplateRef" :tenant-type="tenant_type"/>
                  <b-button variant="outline-secondary" style="margin-top: 5px" @click="show_html_in_browser(add_cust_event_model.email_html_template)">Show html in browser</b-button>
                </br></br>
              Email Subject: 
                  <PfsRichEditor ref="custTripEmailSubjectRef" v-model="add_cust_event_model.email_subject" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.customerAlertEmailSubject" :editor-ref="$refs.custTripEmailSubjectRef" :tenant-type="tenant_type"/>  
                  </br> 
             <span v-if="tenant_type !== 'TBN'">
              Email Config: <JsonObjectListEditor v-model="add_cust_event_model.email_config" fieldKey="add_cust_event_email_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="customer_email_config_columns"/>
                  <b-form-invalid-feedback :state="jsonState('add_cust_event_email_config')">{{ jsonFeedback('add_cust_event_email_config') }}</b-form-invalid-feedback>
              </span></br>
              <span v-if="tenant_aaahi">
              FarmOut SMS Template: 
                <PfsRichEditor ref="customerTripSmsFarmRef" v-model="add_cust_event_model.farm_out_sms_template" style="max-width: 800px"/>
                  <PfsFieldHelp :fields="pfsNotifFields.customerAlert" :editor-ref="$refs.customerTripSmsFarmRef" :tenant-type="tenant_type"/></br>
              </span>

            <div style="margin:5px; color: var(--fi-rail-accent); font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'showAdvCustAlertFilters')">&#43; Show Filters</div>
            <div v-if="toggle.showAdvCustAlertFilters" style="margin-left:10px; padding: 10px; border: 1px solid black">
              Send To Contracts Enabled: <b-form-select v-model="add_cust_event_model.contracts_enabled" :options="boolean_options"/>
              Send To Private Hires Enabled: <b-form-select v-model="add_cust_event_model.private_hires_enabled" :options="boolean_options"/>
              Driver Name Filter:
              <FilterSettingEditor v-model="add_cust_event_model.driver_name_filter" fieldKey="cust_event_driver_name_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              <span v-if="telematics_type == 'SAMSARA'">
              Driver Tag Filter:
              <FilterSettingEditor v-model="add_cust_event_model.driver_tag_filter" fieldKey="cust_event_driver_tag_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Vehicle Tag Filter:
              <FilterSettingEditor v-model="add_cust_event_model.vehicle_tag_filter" fieldKey="cust_event_vehicle_tag_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              </span>
              <span v-if="tenant_type !== 'TBN'">
              Driver Type Filter:
              <FilterSettingEditor v-model="add_cust_event_model.driver_type_filter" fieldKey="cust_event_driver_type_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Vehicle Type Filter:
              <FilterSettingEditor v-model="add_cust_event_model.vehicle_type_filter" fieldKey="cust_event_vehicle_type_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              </span>
              <span v-if="tenant_type == 'TBN'">
              Group Name Filter:
              <FilterSettingEditor v-model="add_cust_event_model.group_name_filter" fieldKey="cust_event_group_name_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Scheduled Service Filter:
              <FilterSettingEditor v-model="add_cust_event_model.scheduled_service_filter" fieldKey="cust_event_scheduled_service_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Route Description Filter:
              <FilterSettingEditor v-model="add_cust_event_model.route_filter" fieldKey="cust_event_route_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              </span>
              <span v-if="tenant_type == 'CM'">
              Booking Base Filter:
              <FilterSettingEditor v-model="add_cust_event_model.booking_base_filter" fieldKey="cust_event_booking_base_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Client ID Filter:
              <FilterSettingEditor v-model="add_cust_event_model.client_id_filter" fieldKey="cust_event_client_id_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              </span>
              Company ID Filter:
              <FilterSettingEditor v-model="add_cust_event_model.company_id_filter" fieldKey="cust_event_company_id_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Filter By Booking Type:
              <FilterSettingEditor v-model="add_cust_event_model.booking_type_filter" fieldKey="cust_event_booking_type_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              <span v-if="tenant_type == 'TBN'">
              Use Operations Contact: <b-form-select v-model="add_cust_event_model.use_operations_contact" :options="boolean_options"/>
              Use Primary Contact: <b-form-select v-model="add_cust_event_model.use_primary_contact" :options="boolean_options"/>
              Organization Name Filter:
              <FilterSettingEditor v-model="add_cust_event_model.org_name_filter" fieldKey="cust_event_org_name_filter" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
            </span>
              SMS Receipients Exclusions:
              <FilterSettingEditor v-model="add_cust_event_model.sms_recipients_exclude" fieldKey="cust_event_sms_recipients_exclude" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Email Receipients Exclusions:
              <FilterSettingEditor v-model="add_cust_event_model.email_recipients_exclude" fieldKey="cust_event_email_recipients_exclude" variant="wildcard" :allow-raw-edit="isEffectiveAdmin" @validation="onFilterValidation" />
              Skip Non Telematics Vehicles: <b-form-select v-model="add_cust_event_model.skip_non_telematics_vehicles" :options="boolean_options"/>
            </div>
            <div style="margin:5px; color: var(--fi-rail-accent); font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'showAdvancedCustAlert')">{{ toggle.showAdvancedCustAlert ? "▾" : "▸" }} Show Advanced</div>
            <div v-if="toggle.showAdvancedCustAlert" style="margin-left:10px; padding: 10px; border: 1px solid black">
              <span v-if="tenant_aaahi">
              Include Driver Name With Farm Out Info: <b-form-select v-model="add_cust_event_model.include_driver_name_with_farm_out" :options="boolean_options"/>
              </span>
                <b-modal title="Supported POC Formats" size="lg" v-model="modal_help.customer_trip_notifications_poc_formats2" ok-only>
                  <p>Use the Booking/Route POC field to store one or more contacts. The parser supports these formats:</p>
                  <ul>
                    <li><b>Single contact (name + phone + email):</b> <code>POC John Smith 555-301-4478 john.smith@masked.test</code></li>
                    <li><b>Single contact without POC label:</b> <code>John Smith 555-301-4478</code>, <code>555-301-4478</code>, <code>john.smith@masked.test</code>, or <code>555-301-4478 john.smith@masked.test</code></li>
                    <li><b>Multiple contacts with POC labels:</b> <code>POC John Smith 555-301-4478 POC Jane Doe 555-664-9281</code></li>
                    <li><b>Multiple contacts without POC labels:</b> <code>John Smith 555-301-4478 Jane Doe 555-664-9281</code> or <code>555-301-4478 john.smith@masked.test 555-664-9281 jane.doe@masked.test</code></li>
                    <li><b>Rich text input from editors:</b> <code>&lt;p&gt;POC John Smith 555-301-4478&lt;/p&gt;&lt;p&gt;POC Jane Doe 555-664-9281&lt;/p&gt;</code> or <code>POC John Smith 555-301-4478&lt;br&gt;POC Jane Doe 555-664-9281</code></li>
                  </ul>
                  <p><b>Phone Number Formats Supported</b></p>
                  <ul>
                    <li><code>555-301-4478</code> (dash-separated)</li>
                    <li><code>(555) 301-4478</code> (parentheses + dash)</li>
                    <li><code>555.301.4478</code> (dot-separated)</li>
                    <li><code>5553014478</code> (digits only)</li>
                    <li><code>+1 555 301 4478</code> (country code + spaces)</li>
                    <li><code>+555 77 91 29 09 63</code> (international-style spacing)</li>
                  </ul>
                </b-modal>
              Booking Field To Find POC Info: <img width="20" src="info-icon.png" @click="toggle_help('customer_trip_notifications_poc_formats2')"/>
                <b-form-input v-model="add_cust_event_model.booking_poc_field" />
              <span v-if="tenant_type == 'TBN'">
              Route Field To Find POC Info: <b-form-input v-model="add_cust_event_model.route_poc_field" />
              Booking Group Field: <b-form-input v-model="add_cust_event_model.group_field" />
              </span>
              <span v-if="tenant_type == 'CM'">
              Client ID POC Override: <b-form-input v-model="add_cust_event_model.client_id_poc_override" />
              </span>
              Email Reply-To Recipients: <b-form-input v-model="add_cust_event_model.email_reply_recipients" />
              POC Error Email Recipients:  <b-form-input v-model="add_cust_event_model.poc_error_email_recipients" />
              Test in browser:
                <span>
                  <a target='_blank' :href="'https://api.fleet-integrations.com/bookings/alerts/showHtml/event?tenant=' + user.tenant + '&type=cust' + '&event_name=' + add_cust_event_model.eventName">
                    <b-button variant="">Show html in browser</b-button>
                  </a>
                </span>
              <br/>
               Test Html Email Address:  <b-form-input v-model="add_cust_event_model.test_html_email_recipients" />
              <b-button v-if="!loading" variant="success" size="sm" @click="test_cust_pre_trip_alert_event_html(add_cust_event_model)">Send Test HTML</b-button>
            </div>

            </b></div><br/>
            <div style="color:red; font-weight:bold;" v-if="this.show_cust_error">
            <b>{{this.cust_error_msg}}</b><br/>
            </div>
            <b-button v-if="!loading" variant="success" size="sm" @click="add_cust_event()">Save Alert Event</b-button>
          </span>
      </div>
    </b-modal>

    <div class="tc-sticky-save">
      <transition name="tc-save-slide">
      <div v-if="isDirty || saving" class="d-flex align-items-center justify-content-center">
        <span v-if="isDirty && !saving" class="tc-unsaved-label mr-3" @click="scrollToFirstDirtyField()" title="Click to scroll to unsaved field" style="cursor:pointer">&#9679; Unsaved changes</span>
        <b-btn size="lg" variant="success" @click="save_config" :disabled="saving">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          {{ saving ? 'Saving...' : 'Save' }}
        </b-btn>
        &nbsp;&nbsp;
        <b-btn size="lg" variant="secondary" @click="load_data(true)">Discard Changes</b-btn>
      </div>
      </transition>
    </div>
  </div>

</template>
<script>
import {get_tenant_config_settings, add_cust_event, delete_cust_event, test_html_alert, test_html_alert_param, update_tenant_config_settings} from '../networking/apis'
import {mapState} from "vuex";
import filterValidationMixin from '../mixins/filter_validation_mixin'
import numericValidationMixin from '../mixins/numeric_validation_mixin'
import jsonValidationMixin from '../mixins/json_validation_mixin'
import dirtyTrackingMixin from '../mixins/dirty_tracking_mixin'
import confirmDefaultsMixin from '../mixins/confirm_defaults_mixin'
import { provide } from "vue";
import { RichTextEditorComponent as EjsRichtexteditor, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar } from '@syncfusion/ej2-vue-richtexteditor';
import JsonObjectListEditor from './JsonObjectListEditor.vue'
import FilterSettingEditor from './FilterSettingEditor.vue'
import { ensureFilterKeys } from '../utils/filter_syntax'
import PfsRichEditor from './PfsRichEditor.vue'
import PfsFieldHelp from './PfsFieldHelp.vue'
import { DRIVER_TRIP_FIELDS, DRIVER_POST_TRIP_FIELDS, CUSTOMER_ALERT_FIELDS, CUSTOMER_PRE_TRIP_EMAIL_FIELDS, CUSTOMER_ALERT_EMAIL_SUBJECT_FIELDS, CUSTOMER_POST_TRIP_FIELDS, CUSTOMER_POST_TRIP_EMAIL_SUBJECT_FIELDS, DRIVER_SURVEY_FIELDS, PASSENGER_TRIP_FIELDS, RELAY_NOTIFICATION_FIELDS } from '../utils/pfs_fields'

const CUST_EVENT_MODAL_FILTER_KEYS = [
  'driver_name_filter',
  'driver_tag_filter',
  'vehicle_tag_filter',
  'driver_type_filter',
  'vehicle_type_filter',
  'group_name_filter',
  'scheduled_service_filter',
  'route_filter',
  'booking_base_filter',
  'client_id_filter',
  'company_id_filter',
  'booking_type_filter',
  'org_name_filter',
  'sms_recipients_exclude',
  'email_recipients_exclude',
]

// Plain-text PFS template fields must never be JSON-parsed, matching the backend
// exclude logic in fleet-int-api/util/manage_tenant_settings.py.
function isPfsTemplateField(key) {
  return key.includes('_template') || key.endsWith('_email_subject') || key.endsWith('_voice_message')
}


export default {
  name: 'tenant_config',
  mixins: [filterValidationMixin, numericValidationMixin, jsonValidationMixin, dirtyTrackingMixin, confirmDefaultsMixin],
  components: {
    JsonObjectListEditor,
    FilterSettingEditor,
    PfsRichEditor,
    PfsFieldHelp,
  },
  provide:{
    richtexteditor:[Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar]
  },

  data() {
    return {
      pfsNotifFields: {
        driverTrip: DRIVER_TRIP_FIELDS,
        driverPostTrip: DRIVER_POST_TRIP_FIELDS,
        customerAlert: CUSTOMER_ALERT_FIELDS,
        customerPreTripEmail: CUSTOMER_PRE_TRIP_EMAIL_FIELDS,
        customerAlertEmailSubject: CUSTOMER_ALERT_EMAIL_SUBJECT_FIELDS,
        customerPostTrip: CUSTOMER_POST_TRIP_FIELDS,
        customerPostTripEmailSubject: CUSTOMER_POST_TRIP_EMAIL_SUBJECT_FIELDS,
        driverSurvey: DRIVER_SURVEY_FIELDS,
        passenger: PASSENGER_TRIP_FIELDS,
        relay: RELAY_NOTIFICATION_FIELDS,
      },
      cust_alert_event_settings: null,
      add_cust_event_model: {},
      manage_cust_events: false,
      show_cust_error: false,
      disable_cust_options: false,
      disable_cust_name: false,
      cust_error_msg: "",
      model: {},
      toggle: {
        isGroupMessageSenderVisible: false,
        isDriverPreVisible: false,
        isDriverPostVisible: false,
        isCustomerPreVisible: false,
        isCustDefaultSettingsVisible: false,
        isCustomerPostVisible: false,
        isDriverSurveyVisible: false,
        isPassPreVisible: false,
        isRelayVisible: false,
        isAddCustEventVisible: false,
        showAdvCustAlertFilters: false,
        showAdvancedCustAlert: false,
      },
      summary: {},
      loading: true,
      objectKeyList: [],
      modal_help: {},
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
      response_email_config_columns: [
        { key: 'company_id', label: 'Company ID', placeholder: 'optional' },
        { key: 'email', label: 'Email Recipients', placeholder: 'email@example.com' },
      ],
      confirmation_advanced_columns: [
        { key: 'minutes_threshold', label: 'Minutes Threshold', type: 'number', placeholder: 'e.g. 60' },
        { key: 'time_window_mode', label: 'Time Window Mode', placeholder: 'e.g. am_pm' },
        { key: 'email_recipients', label: 'Email Recipients', placeholder: 'comma-separated' },
        { key: 'sms_recipients', label: 'SMS Recipients', placeholder: 'comma-separated' },
      ],
      customer_email_config_columns: [
        { key: 'start_base', label: 'Start Base', placeholder: 'base name' },
        { key: 'subject', label: 'Email Subject', placeholder: 'optional override' },
        { key: 'sender_prefix', label: 'Sender Prefix', placeholder: 'e.g. noreply' },
        { key: 'response_forward', label: 'Response Forward', placeholder: 'email@example.com' },
      ],
      cust_event_options: [
        { text: 'HoursBefore', value: 'hrsbfr' },
        { text: 'HoursByDay', value: 'hrsbday' },
        { text: 'OnlyAtHour', value: 'onlyhr' },
        { text: 'BusinessHours', value: 'bushrs' },
      ],
      post_trip_response_email_columns: [
        { key: 'departure', label: 'Departure Address', placeholder: 'e.g. 123 Main St' },
        { key: 'email', label: 'Email Recipients', placeholder: 'comma-separated emails' },
      ],
      fieldPrefixSectionMap: [
        ['group_message_sender_', 'isGroupMessageSenderVisible'],
        ['driver_trip_notifications_', 'isDriverPreVisible'],
        ['post_trip_notifications_', 'isDriverPostVisible'],
        ['customer_trip_notifications_', 'isCustomerPreVisible'],
        ['customer_post_trip_notifications_', 'isCustomerPostVisible'],
        ['driver_surveys_', 'isDriverSurveyVisible'],
        ['passenger_trip_notifications_', 'isPassPreVisible'],
        ['relay_notifications_', 'isRelayVisible'],
      ],
      jsonFieldToggleMap: {
        driver_trip_notifications_response_email_config: 'isDriverPreVisible',
        driver_trip_notifications_confirmation_advanced_config: 'isDriverPreVisible',
        customer_trip_notifications_email_config: 'isCustomerPreVisible',
        customer_post_trip_notifications_email_config: 'isCustomerPostVisible',
        post_trip_notifications_response_email_config: 'isDriverPostVisible',
      },
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    toggle_help(field) {
      this.$set(this.modal_help, field, !this.modal_help[field])
    },
    apply_driver_pre_trip_defaults() {
      this.model = {
        ...this.model,
        driver_trip_notifications_enabled: 'True',
        driver_trip_notifications_test_mode: 'True',
        driver_trip_notifications_contracts_enabled: 'True',
        driver_trip_notifications_private_hires_enabled: 'True',
        driver_trip_notifications_send_hours_before: '1',
        driver_trip_notifications_send_only_at_hour: '12',
        driver_trip_notifications_confirmation_enabled: 'False',
        driver_trip_notifications_skip_non_telematics_vehicles: 'False',
        driver_trip_notifications_sms_template: 'Driver Trip Notification\nBooking: [charterID]\nStart Time: [startTime]\nVehicle: [vehicleID]\nPickup Time: [pickupTime]\nPickup: [pickupLocation]',
      }
      this.$bvToast.toast('Driver pre-trip defaults applied — add recipients and save.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    apply_driver_post_trip_defaults() {
      this.model = {
        ...this.model,
        post_trip_notifications_enabled: 'True',
        post_trip_notifications_email_only: 'False',
        post_trip_notifications_send_to_driver: 'False',
        post_trip_notifications_send_after_complete: 'False',
        post_trip_notifications_confirmation_enabled: 'False',
        post_trip_notifications_send_minutes_after: '15',
        post_trip_notifications_sms_template: 'Hi [driverFirstName], your trip [charterID] is now complete. Please submit your post-trip DVIR.',
      }
      this.$bvToast.toast('Driver post-trip defaults applied — add recipients and save.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    apply_customer_post_trip_defaults() {
      this.model = {
        ...this.model,
        customer_post_trip_notifications_enabled: 'True',
        customer_post_trip_notifications_test_mode: 'True',
        customer_post_trip_notifications_send_minutes_after_planned_dropoff: '30',
        customer_post_trip_notifications_booking_poc_field: 'FurtherRequirements',
        customer_post_trip_notifications_client_cooldown_enabled: 'True',
        customer_post_trip_notifications_client_cooldown_months: '3',
        customer_post_trip_notifications_sms_template: 'Thank you for riding with us! We hope you had a great experience.',
        customer_post_trip_notifications_email_subject: 'Thank You for Traveling with Us',
        customer_post_trip_notifications_email_template: `<html><body style="font-family:Arial,sans-serif;color:#333;max-width:600px;margin:0 auto;padding:20px;">
<h2 style="color:#2c3e50;margin-bottom:16px;">Thank You!</h2>
<p style="font-size:14px;">Your trip on <strong>[startDate]</strong> has been completed. We hope you had a great experience.</p>
<p style="margin-top:24px;font-size:13px;color:#7f8c8d;">Thank you for choosing us. We look forward to serving you again.</p>
</body></html>`,
      }
      this.$bvToast.toast('Customer post-trip defaults applied — add recipients and save.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    apply_passenger_pre_trip_defaults() {
      this.model = {
        ...this.model,
        passenger_trip_notifications_enabled: 'True',
        passenger_trip_notifications_email_only: 'False',
        passenger_trip_notifications_hours_before: '24',
        passenger_trip_notifications_sms_template: 'Your pickup is confirmed for [startDate] at [startTime]. Vehicle: [vehicleID]. Driver: [driverFirstName].',
      }
      this.$bvToast.toast('Passenger pre-trip defaults applied — add recipients and save.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    apply_relay_defaults() {
      this.model = {
        ...this.model,
        relay_notifications_enabled: 'True',
        relay_notifications_test_mode: 'True',
        relay_notifications_email_only: 'False',
        relay_notifications_minutes_threshold: '20',
        relay_notifications_distance_threshold: '10',
        relay_notifications_minutes_before: '60',
        relay_notifications_minutes_after: '240',
        relay_notifications_api_enabled: 'False',
        relay_notifications_sms_template: 'Relay Alert: [vehicleID] may not make connection. [driverFirstName] [driverLastName] - please check schedule.',
      }
      this.$bvToast.toast('Relay defaults applied — add recipients and save.', { variant: 'success', autoHideDelay: 5000, solid: true, noCloseButton: true })
    },
    async apply_customer_pre_trip_event_defaults() {
      const defaults = [
        {
          eventType: 'onlyhr',
          eventName: 'Day Before Notification',
          hours: '12',
          contracts_enabled: 'True',
          private_hires_enabled: 'True',
          test_mode: 'True',
          template: 'Your transportation is confirmed for [startTime]. Vehicle: [vehicleID], Driver: [driverFirstName] [driverLastName]. Reply STOP to unsubscribe.',
          email_subject: 'Your Upcoming Trip - [startDate]',
          email_html_template: `<html><body style="font-family:Arial,sans-serif;color:#333;max-width:600px;margin:0 auto;padding:20px;"><h2 style="color:#2c3e50;margin-bottom:16px;">Trip Confirmation</h2><table style="width:100%;border-collapse:collapse;font-size:14px;"><tr><td style="padding:8px 0;border-bottom:1px solid #eee;color:#7f8c8d;width:140px;">Date</td><td style="padding:8px 0;border-bottom:1px solid #eee;"><strong>[startDate]</strong></td></tr><tr><td style="padding:8px 0;border-bottom:1px solid #eee;color:#7f8c8d;">Pickup Time</td><td style="padding:8px 0;border-bottom:1px solid #eee;"><strong>[startTime]</strong></td></tr><tr><td style="padding:8px 0;border-bottom:1px solid #eee;color:#7f8c8d;">Pickup Location</td><td style="padding:8px 0;border-bottom:1px solid #eee;">[pickupLocation]</td></tr><tr><td style="padding:8px 0;border-bottom:1px solid #eee;color:#7f8c8d;">Destination</td><td style="padding:8px 0;border-bottom:1px solid #eee;">[destinationLocation]</td></tr><tr><td style="padding:8px 0;color:#7f8c8d;">Driver</td><td style="padding:8px 0;">[driverName]</td></tr></table><p style="margin-top:24px;font-size:13px;color:#7f8c8d;">If you have any questions please contact us directly.</p></body></html>`,
          booking_poc_field: 'FurtherRequirements',
        },
        {
          eventType: 'hrsbfr',
          eventName: '1 Hour Before',
          hours: '1',
          contracts_enabled: 'True',
          private_hires_enabled: 'True',
          test_mode: 'True',
          template: 'Reminder: Your transportation is arriving soon. Vehicle: [vehicleID], Driver: [driverFirstName] [driverLastName]. Pickup at [startTime].',
          email_subject: 'Reminder: Your Trip is Coming Up - [startDate]',
          email_html_template: `<html><body style="font-family:Arial,sans-serif;color:#333;max-width:600px;margin:0 auto;padding:20px;"><h2 style="color:#2c3e50;margin-bottom:16px;">Trip Reminder</h2><table style="width:100%;border-collapse:collapse;font-size:14px;"><tr><td style="padding:8px 0;border-bottom:1px solid #eee;color:#7f8c8d;width:140px;">Date</td><td style="padding:8px 0;border-bottom:1px solid #eee;"><strong>[startDate]</strong></td></tr><tr><td style="padding:8px 0;border-bottom:1px solid #eee;color:#7f8c8d;">Pickup Time</td><td style="padding:8px 0;border-bottom:1px solid #eee;"><strong>[startTime]</strong></td></tr><tr><td style="padding:8px 0;border-bottom:1px solid #eee;color:#7f8c8d;">Pickup Location</td><td style="padding:8px 0;border-bottom:1px solid #eee;">[pickupLocation]</td></tr><tr><td style="padding:8px 0;border-bottom:1px solid #eee;color:#7f8c8d;">Destination</td><td style="padding:8px 0;border-bottom:1px solid #eee;">[destinationLocation]</td></tr><tr><td style="padding:8px 0;color:#7f8c8d;">Driver</td><td style="padding:8px 0;">[driverName]</td></tr></table><p style="margin-top:24px;font-size:13px;color:#7f8c8d;">Your transportation will be arriving shortly. Please be ready at your pickup location.</p></body></html>`,
          booking_poc_field: 'FurtherRequirements',
        },
      ]
      if (!this.cust_alert_event_settings) this.cust_alert_event_settings = []
      const existing_names = this.cust_alert_event_settings.map(e => e.eventName)
      for (const event of defaults) {
        if (!existing_names.includes(event.eventName)) {
          await add_cust_event(this.user.tenant, event)
          this.cust_alert_event_settings.push(event)
        }
      }
      this.$bvToast.toast('Default customer pre-trip events added — add recipients and save to confirm.', { variant: 'success', autoHideDelay: 4000, solid: true, noCloseButton: true })
    },
    async load_data(silent = false) {
      if (!silent) this.loading = true
      this.objectKeyList = []
      let loaded = false
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        // The backend reads several filter fields with a plain `.get()` and no
        // schema default, so they may be entirely absent from `data.results`
        // for tenants that never set them. Adding a brand-new key later via a
        // plain v-model assignment wouldn't be reactive (classic Vue 2 gotcha),
        // which silently breaks dirty-change detection for that field. Force
        // these keys to exist reactively up front via ensureFilterKeys.
        ensureFilterKeys(this.model, [
          'driver_trip_notifications_skip_routes',
          'driver_trip_notifications_vehicle_tag_filter',
          'driver_trip_notifications_driver_tag_filter',
          'driver_trip_notifications_driver_name_filter',
          'driver_trip_notifications_client_id_filter',
          'driver_trip_notifications_org_name_filter',
          'driver_trip_notifications_booking_base_filter',
          'post_trip_notifications_booking_type_filter',
          'customer_trip_notifications_route_filter',
          'customer_trip_notifications_sms_recipients_exclude',
          'customer_trip_notifications_email_recipients_exclude',
          'customer_trip_notifications_company_id_filter',
          'customer_trip_notifications_booking_type_filter',
          'customer_trip_notifications_client_id_filter',
          'customer_trip_notifications_booking_base_filter',
          'customer_trip_notifications_vehicle_tag_filter',
          'customer_trip_notifications_group_name_filter',
          'customer_trip_notifications_scheduled_service_filter',
          'customer_trip_notifications_driver_type_filter',
          'customer_trip_notifications_vehicle_type_filter',
          'customer_post_trip_notifications_route_filter',
        ])

        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value, key) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }

        try {
          if (this.model.customer_trip_notifications_alerts_settings != null && this.model.customer_trip_notifications_alerts_settings != "") {
            this.cust_alert_event_settings = JSON.parse(this.model.customer_trip_notifications_alerts_settings)

            if (this.cust_alert_event_settings) {
              for (const event of this.cust_alert_event_settings) {
                if (event.dayHours) {
                  for (const dayhrs of event.dayHours.split(';')) {
                    if (dayhrs != null) {
                      const day = dayhrs.split('=')[0]
                      const hrs = dayhrs.split('=')[1]
                      if ('Monday' == day) event['M'] = hrs
                      if ('Tuesday' == day) event['T'] = hrs
                      if ('Wednesday' == day) event['W'] = hrs
                      if ('Thursday' == day) event['TH'] = hrs
                      if ('Friday' == day) event['F'] = hrs
                      if ('Saturday' == day) event['SA'] = hrs
                      if ('Sunday' == day) event['SU'] = hrs
                    }
                  }
                }
              }
            }
          }
        } catch(e) {
          console.log('exception converting cust alert settings to json:', e)
        }
        loaded = true
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
      if (loaded) this._resetDirtyTracking()
    },
    async save_config() {
      try {
        this.saving = true
        this.flushNumericValidation()
        this.flushFilterValidation()
        if (this.hasNumericErrors()) {
          this.$emit('showAlert', 'Fix the highlighted field before saving', 'danger', 6000)
          this.scrollToFirstNumericError()
          return
        }
        if (this.hasFilterErrors()) {
          this.$emit('showAlert', 'Fix the highlighted filter field before saving', 'danger', 6000)
          this.scrollToFirstFilterError()
          return
        }
        if (this.hasJsonErrors()) {
          this.$emit('showAlert', 'Invalid JSON in field: ' + this.firstJsonErrorKey() + ' — ' + this.jsonFeedback(this.firstJsonErrorKey()), 'danger', 8000)
          this.expandAndScrollToJsonError()
          return
        }
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        // Compute dirty keys before parsing (model still holds JSON strings matching snapshot).
        const dirtyKeys = new Set(Object.keys(this._dirtyFields()))
        const fullPayload = Object.assign({}, this.model)
        for (const objkey of this.objectKeyList) {
          try {
            if (fullPayload[objkey] && fullPayload[objkey].trim && fullPayload[objkey].trim() !== '') {
              fullPayload[objkey] = JSON.parse(fullPayload[objkey])
            }
          } catch (e) {
            this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
            this.expandAndScrollToJsonError()
            this.load_data()
            return
          }
        }
        const payload = {}
        for (const key of dirtyKeys) {
          if (key in fullPayload) payload[key] = fullPayload[key]
        }

        await update_tenant_config_settings(this.user.tenant, payload)
        this._resetDirtyTracking()
        await this.load_data(true)
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', this._saveErrorMessage(e), 'danger', 5000)
      }
      finally {
        this.saving = false
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.cust_alert_event_settings = null
      this.manage_cust_events = false
      this.reset_cust_event_modal_state()
      this.load_data()
    },
    update_toggle_div(item, field, setting) {
      if (item[field] !== setting) {
        this.$set(item, field, setting)
      }
    },
    toggle_div(item, field) {
      this.$set(item, field, !item[field])
    },
    show_html_in_browser(template) {
      if (!template) {
        alert("No HTML template to preview")
        return
      }
      const win = window.open('', '_blank')
      win.document.write(template)
      win.document.close()
    },
    async test_cust_pre_trip_alert_event_html(event_model) {
      let event_name = ''
      if(event_model && event_model.test_html_email_recipients) {
        event_name = event_model.eventName
      } else {
        alert("Please enter an email address above and save")
        return
      }
      if (!event_model.email_html_template) {
        alert("Please enter a template and save")
        return
      }
      if (confirm("Are you sure you want to send test customer pre-trip notifications email?")) {
        await test_html_alert_param(this.user.tenant, "CustomerTripNotificationTest",event_name)
        this.$emit('showAlert', 'test html sent', 'info', 5000)
      }
    },
    async test_driver_survey_alert_html() {
      if (!this.model.driver_surveys_test_html_email_address) {
        alert("Please enter an email address above and save")
        return
      }
      if (!this.model.driver_surveys_html_template) {
        alert("Please enter a template and save")
        return
      }
      if (confirm("Are you sure you want to send test customer survey notifications email?")) {
        await test_html_alert(this.user.tenant, "DriverTripNotificationTest")
        this.$emit('showAlert', 'test html sent', 'info', 5000)
      }
    },
    reset_cust_event_modal_state() {
      this.add_cust_event_model = {}
      // Pre-existing gap: filterErrors never gets cleared on modal open/close (only
      // on `loading` becoming true), so a stale red state from one edit session
      // could otherwise leak into the next. Clear this modal's filter keys here.
      CUST_EVENT_MODAL_FILTER_KEYS.forEach(k => this.$set(this.filterErrors, `cust_event_${k}`, ''))
      this.cust_error_msg = ""
      this.show_cust_error = false
      this.disable_cust_options = false
      this.disable_cust_name = false
      this.update_toggle_div(this.toggle, 'isAddCustEventVisible', false)
      this.update_toggle_div(this.toggle, 'showAdvCustAlertFilters', false)
      this.update_toggle_div(this.toggle, 'showAdvancedCustAlert', false)
    },
    open_manage_cust_events() {
      this.reset_cust_event_modal_state()
      this.manage_cust_events = true
    },
    async custModelOK($event) {
      this.reset_cust_event_modal_state()
    },
    process_dayhours(event) {
      //console.log("process_dayhours: new cust_alert_event_settings: " + JSON.stringify(event))
      if (event.eventType === 'hrsbday') {
        let dayhours = ""
        if (event.M != null) {
          dayhours += "Monday=" + event.M + ";"
          delete event.M
        }
        if (event.T) {
          dayhours += "Tuesday=" + event.T + ";"
          delete event['T']
        }
        if (event.W) {
          dayhours += "Wednesday=" + event.W + ";"
          delete event.W
        }
        if (event.TH) {
          dayhours += "Thursday=" + event.TH + ";"
          delete event.TH
        }
        if (event.F) {
          dayhours += "Friday=" + event.F + ";"
          delete event.F
        }
        if (event.SA) {
          dayhours += "Saturday=" + event.SA + ";"
          delete event.SA
        }
        if (event.SU) {
          dayhours += "Sunday=" + event.SU + ";"
          delete event.SU
        }
        dayhours = dayhours.slice(0, -1);
        event['dayHours'] = dayhours
        //console.log('dayhours = ' + dayhours)
      }
    },
    eval_event() {
      const type = this.add_cust_event_model.eventType
      this.add_cust_event_model = {}
      this.add_cust_event_model.eventType = type
    },
    async add_cust_event() {
      this.loading=true
      this.show_cust_error = false
      this.cust_error_msg = ""
      if (!this.add_cust_event_model.eventName || !this.add_cust_event_model.eventType || 
        (!this.add_cust_event_model.template && !this.add_cust_event_model.email_html_template)) {
        this.show_cust_error = true
        this.cust_error_msg = "event name, type and sms or email template are required"
        this.loading = false
      } else {
        let cust_alert_event_item = []
        if (this.cust_alert_event_settings != null && this.cust_alert_event_settings != "" && Array.isArray(this.cust_alert_event_settings)) {
          cust_alert_event_item = this.cust_alert_event_settings.filter(element => element.eventName === this.add_cust_event_model.eventName)[0]
        }
        if (cust_alert_event_item && cust_alert_event_item.eventName === this.add_cust_event_model.eventName) {
          this.save_cust_event()
        } else {
          let cust_alert_event_items = []
          if (this.cust_alert_event_settings) {
            cust_alert_event_items = this.cust_alert_event_settings.filter(element => element.eventType == this.add_cust_event_model.eventType)
          }
          if (cust_alert_event_items && cust_alert_event_items.length > 5) {
            this.show_cust_error = true
            this.cust_error_msg = "Only six of each event type is allowed, please remove or update current"
            this.loading = false
          } else {
            if (this.cust_alert_event_settings && this.cust_alert_event_settings.length == 15) {
              this.show_cust_error = true
              this.cust_error_msg = "Only 15 total events are allowed"
              this.loading = false
              this.cancel_save_event()
            } else {
              this.save_cust_event()
            }
          }
        }
      }
    },
    async save_cust_event() {
      this.process_dayhours(this.add_cust_event_model)
      if (!this.show_cust_error) {
        await add_cust_event(this.user.tenant, this.add_cust_event_model)
        await update_tenant_config_settings(this.user.tenant, { customer_trip_notifications_route_filter: this.model.customer_trip_notifications_route_filter })
        this.add_cust_event_model = {}
        this.toggle_div(this.toggle, 'isAddCustEventVisible')
        await this.load_data()
      } else {
        this.cancel_save_event()
      }
    },
    async cancel_save_cust_event() {
      this.toggle_div(this.toggle, 'isAddCustEventVisible')
      this.manage_cust_events = false
      this.add_cust_event_model = {}
      this.cust_error_msg = ""
      this.show_cust_error = false
      await this.load_data()
    },
    async update_cust_event(event_name) {
      let cust_alert_event_item = null
      if (this.cust_alert_event_settings){
        cust_alert_event_item = this.cust_alert_event_settings.filter(element => element.eventName == event_name)[0]
      }
      if (cust_alert_event_item) {
        this.update_toggle_div(this.toggle, 'isAddCustEventVisible', true)
        // Edit a copy, not the live list item. ensureFilterKeys (and any
        // subsequent modal edits) would otherwise mutate the object still
        // referenced by cust_alert_event_settings, leaking empty filter keys
        // into it even if the user cancels.
        this.add_cust_event_model = { ...cust_alert_event_item }
        ensureFilterKeys(this.add_cust_event_model, CUST_EVENT_MODAL_FILTER_KEYS)
        this.disable_cust_options = true
        this.disable_cust_name = true
      }
      this.cust_error_msg = ""
      this.show_cust_error = false
    },
    async add_new_alert() {
      this.toggle_div(this.toggle, 'isAddCustEventVisible')
      this.add_cust_event_model = {}
      ensureFilterKeys(this.add_cust_event_model, CUST_EVENT_MODAL_FILTER_KEYS)
      this.cust_error_msg = ""
      this.show_cust_error = false
      this.disable_cust_options = false
      this.disable_cust_name = false
    },
    async delete_cust_event(event_name) {
      if (!confirm(`Remove alert event "${event_name}"? This cannot be undone.`)) return
      this.loading=true
      await delete_cust_event(this.user.tenant, event_name)
      this.show_cust_error = false
      this.cust_error_msg = ""
      await this.load_data()
    },
    isSendHoursEnabled(event) {
      return (event.eventType == 'hrsbday' || event.eventType == 'onlyhr')
    },
    isHrsBfDisabled(event) {
      return (event.eventType != 'hrsbfr')
    },
    isDayDisabled(event) {
      return (event.eventType != 'hrsbday')
    },
    isOnlyHrDisabled(event) {
      return (event.eventType != 'onlyhr')
    },
    isBusHrsDisabled(event) {
      return (event.eventType != 'bushrs')
    },
    isPlainObject(value,key) {
      if (isPfsTemplateField(key)) return false
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value, key) {
      if (isPfsTemplateField(key)) return false
      return Array.isArray(value)
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    isEffectiveAdmin() {
      return this.user.role === 'admin' && this.viewAs !== 'non-admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    },
    tenant_aaahi() {
      if (this.user.tenant_options.length > 0) {
        const matchingKey = Object.keys(this.user.tenant_options).find(key => {
          const value = this.user.tenant_options[key];
          return value && value.value === this.user.tenant
        });
        const name = this.user.tenant_options[matchingKey].text
        return name && name.includes("AAAHI")
      }
      return false;
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
</style>
